var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',_vm._b({},'v-avatar',_vm.$attrs,false),[(_vm.src)?_c('v-img',{attrs:{"src":_vm.src,"alt":"Avatar"}}):_c('v-icon',{attrs:{"color":_vm.iconColor,"size":_vm.$attrs.size}},[_vm._v(" mdi-account-circle ")]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }